import { Box, CircularProgress } from '@mui/material';

// Círculo de "carregando" centralizado na área de conteúdo da página.
// O menu lateral e o topo continuam visíveis; só o miolo da página fica com o círculo no meio.
// Uso: <Carregando />   (opcional: tamanho={32} para um círculo menor)
export default function Carregando({ tamanho = 40 }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: '55vh' }}
    >
      <CircularProgress size={tamanho} aria-label="Carregando" />
    </Box>
  );
}
